import * as moment from 'moment-timezone';

export const calculateAgeFromDate = (date: Date): Number => {
  if (!date) {
    return 0;
  }

  const today = new Date();
  const birthDate = new Date(date);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const getSlotHumanReadableFormat = slot =>
  `${moment().hour(slot.start).format('hA')}-${moment().hour(slot.end).format('hA')}`;

export const getMemberAgeRange = () => {
  let agesRange = [];
  for (let i = 0; i < 23; i++) {
    agesRange.push({ label: i + 13, value: i + 13 });
  }
  agesRange.push({ label: '36+', value: '36+' });
  return agesRange;
}

export const getLastActivities = () => {
  return [
    { id: 'all', name: 'All' },
    { id: 'Past 24 hrs', name: 'Past 24 hrs' },
    { id: '1 week', name: '1 week' },
    { id: '1 month', name: '1 month' },
    { id: '3 months', name: '3 months' },
    { id: '6 months', name: '6 months' },
    { id: '1 year', name: '1 year' },
    { id: '1+ years', name: '1+ years' }
  ];;

}